(document.addEventListener("DOMContentLoaded", ()=> {

  const setText = () => {
    
    const settings = {
      addToCartLabel: "Add To Shopping Bag",
      preOrderAddToCartLabel: "Pre-Order"
    }

    var element = document.querySelector(".form-control>select");
    var val = element.options[element.selectedIndex].value;
    
    const quolity = document.querySelector(`.form-control>select [value='${val}']`).dataset.inventory_quantity
    if(quolity > 0){
      document.querySelector('#button-add-to-cart').textContent = settings.addToCartLabel
    }else{
      document.querySelector('#button-add-to-cart').textContent = settings.preOrderAddToCartLabel
    }
    
  }
  
  setText()
  
  Array.from(document.querySelectorAll('select')).forEach((e)=>{
    e.addEventListener('change', setText)
  })
  

}))